export const COLLECTION_CHURCH = 'church';
export const COLLECTION_CHURCH_RECOMMENDATION = 'recommendation';
export const COLLECTION_CHURCH_ELECTION = 'election';
export const COLLECTION_CHURCH_DELIBERATION = 'deliberation';
export const COLLECTION_KEYS = 'keys';
